import React from 'react';

export default function (props) {
    const o = props.data;
    const testData = props.test;

    let destinationView;
    if (o.orderType === "pickupAppBulk") {
        destinationView = (
            <div className="row">
                <div className="col-1 px-0">
                    <span className="text-danger">
                        <i className="fas fa-map-marker-alt mt-1"/>
                    </span>
                </div>
                <div className="col-11 pl-0">
                    <strong>Pengiriman Banyak</strong><br/>
                    {o.receiverNote} total destinasi pengiriman
                </div>
            </div>
        )
    } else {
        destinationView = (
            <div className="row">
                <div className="col-1 px-0">
                    <span className="text-danger">
                        <i className="fas fa-map-marker-alt mt-1"/>
                    </span>
                </div>
                <div className="col-11 pl-0">
                    <strong>{o.receiverName}</strong> <br/>
                    {o.receiverPhone}<br/>
                    {o.receiverLocation} <br/>
                    <i>{o.receiverNote === "-" ? null : o.receiverNote}</i>
                </div>
            </div>
        )
    }


    let orderChannel;
    if (o.orderType === 'woocommerce') {
        orderChannel = (
            <div>
                <span className="badge badge-woo">WooCommerce</span>
            </div>
        )
    } else if (o.orderType.includes('shopify')) {
      orderChannel = (
          <div>
              <span className="badge badge-shopify">Shopify</span>
          </div>
      )
    } else if (testData === 'active') {
        orderChannel = (
          <div>
              <span className="badge badge-warning">Order Test</span>
          </div>
        )
    }

  return (
    <div>
        {orderChannel}
      <small>ORDER ID: {o.orderId.toUpperCase()}</small>
      <div className="pl-3">
        <div className="row">
          <div className="col-1 px-0">
           <span className="text-primary">
            <i className="fas fa-map-marker-alt mt-1"/>
          </span>
          </div>
          <div className="col-11 pl-0">
            <strong>{o.originName}</strong> <br/>
            {o.originPhone} <br/>
            {o.originLocation} <br/>
            <i>{o.originNote === '-' ? null : o.originNote}</i>
          </div>
        </div>
        <div className="py-1"/>
          {destinationView}
      </div>
    </div>
  )
}